import { render, staticRenderFns } from "./PropertySwitch.vue?vue&type=template&id=4a418b45&"
import script from "./PropertySwitch.vue?vue&type=script&lang=js&"
export * from "./PropertySwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports